const rank = { preferred: 0, backup: 1, unclassified: 2, declined: 3 };
export const preferenceLabels = {
  unclassified: 'Unclassified', preferred: 'Preferred', backup: 'Backup', declined: 'Declined'
};

export function comparisonRows(quotes, { hideApi = false, hideAuthorized = false, sort = null } = {}) {
  return quotes.filter(quote => !(hideApi && quote.source === 'api') && !(hideAuthorized && quote.authorized))
    .flatMap(quote => quote.no_bid ? [{ ...quote, row_id: quote.quote_id, status: 'no_bid' }]
      : quote.price_breaks.map(tier => ({
        ...quote, ...tier, row_id: `${quote.quote_id}:${tier.break_id}`, status: 'quoted'
      })))
    .sort((a, b) => {
      const group = (a.no_bid ? 4 : rank[a.preference || 'unclassified'])
        - (b.no_bid ? 4 : rank[b.preference || 'unclassified']);
      if (group) return group;
      if (sort) {
        const av = a[sort.field] ?? '', bv = b[sort.field] ?? '';
        return (typeof av === 'number' && typeof bv === 'number'
          ? av - bv : String(av).localeCompare(String(bv), undefined, { numeric: true })) * sort.direction;
      }
      return Number(b.authorized) - Number(a.authorized)
        || String(a.vendor_name).localeCompare(String(b.vendor_name))
        || (Number(a.quantity) - Number(b.quantity));
    });
}

export function downloadResult(result) {
  const anchor = document.createElement('a');
  anchor.href = result.url; anchor.rel = 'noreferrer';
  document.body.appendChild(anchor); anchor.click(); anchor.remove();
}

export const errorMessage = error => error.response?.data?.error || error.message || 'Request failed.';
